export default "__VITE_ASSET__0b9ecfbc__"